module.exports = __webpack_public_path__ + "img/arrow2.df212989.svg";